import { Injectable } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';

@Injectable({
  providedIn: 'root'
})
export class ImagesService {
  constructor(private storage: AngularFireStorage) { }

  uploadImage(filePath: any, file: any) {
    return new Promise((resolve, reject) => {
      this.storage.upload(filePath, file).then((img) => {
        img.ref
          .getDownloadURL()
          .then(res => {
            resolve(res);
          })
          .catch((err: any) => {
            reject('Fail upload ' + err);
          });
      });
    });
  }
}
